import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiLock, FiUnlock, FiEye, FiEyeOff, FiShield } = FiIcons;

const LockScreen = ({ onUnlock }) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [attempts, setAttempts] = useState(0);
  const [lockTime, setLockTime] = useState(null);

  const CORRECT_PASSWORD = 'prosomo2025!';// Default password

  const handleUnlock = (e) => {
    e.preventDefault();
    if (lockTime && Date.now() < lockTime) {
      const remaining = Math.ceil((lockTime - Date.now()) / 1000);
      alert(`Too many failed attempts. Please wait ${remaining} seconds.`);
      return;
    }

    if (password === CORRECT_PASSWORD) {
      setAttempts(0);
      localStorage.setItem('prosomo_auth', 'authenticated');
      onUnlock();
    } else {
      const newAttempts = attempts + 1;
      setAttempts(newAttempts);
      if (newAttempts >= 3) {
        const lockDuration = Math.min(newAttempts - 2, 5) * 30 * 1000;
        setLockTime(Date.now() + lockDuration);
        alert(`Too many failed attempts. Locked for ${lockDuration / 1000} seconds.`);
      } else {
        alert('Incorrect password. Please try again.');
      }
      setPassword('');
    }
  };

  const getLockMessage = () => {
    if (lockTime && Date.now() < lockTime) {
      const remaining = Math.ceil((lockTime - Date.now()) / 1000);
      return `Too many failed attempts. Please wait ${remaining} seconds.`;
    }
    if (attempts > 0) {
      return `${3 - attempts} attempts remaining`;
    }
    return 'Enter password to access Prosomo SEO Writer';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 via-purple-600 to-indigo-700 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <div className="bg-gradient-to-r from-blue-500 to-purple-600 p-4 rounded-full">
              <SafeIcon icon={FiShield} className="text-4xl text-white" />
            </div>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2"> Prosomo SEO Writer </h1>
          <p className="text-gray-600">Secure Access Required</p>
        </div>
        <form onSubmit={handleUnlock} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2"> Password </label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter access password"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 pr-12"
                disabled={lockTime && Date.now() < lockTime}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <SafeIcon icon={showPassword ? FiEyeOff : FiEye} className="text-lg" />
              </button>
            </div>
          </div>
          <div className="text-center">
            <p className={`text-sm mb-4 ${lockTime && Date.now() < lockTime ? 'text-red-600 font-medium' : 'text-gray-500'}`}>
              {getLockMessage()}
            </p>
            <button
              type="submit"
              disabled={lockTime && Date.now() < lockTime}
              className="w-full flex items-center justify-center space-x-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-4 rounded-lg hover:from-blue-700 hover:to-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 font-medium"
            >
              <SafeIcon icon={FiUnlock} className="text-lg" />
              <span>Unlock Application</span>
            </button>
          </div>
        </form>
        <div className="mt-6 pt-6 border-t border-gray-200">
          <div className="flex items-center justify-center space-x-2 text-sm text-gray-500">
            <SafeIcon icon={FiLock} className="text-sm" />
            <span>Your content is securely protected</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LockScreen;